import React from 'react';
import CONSTANTS from './constants.js'
import {connect} from 'react-redux'

const mapDispatchToProps =  (dispatch) => {
    return {
        timerControler: () => dispatch(CONSTANTS.ACTION_CREATORS.timer_set_active()),
        setTimerID: (timerID) => dispatch(CONSTANTS.ACTION_CREATORS.set_timer_id(timerID)),
        startStopPressed: () => dispatch(CONSTANTS.ACTION_CREATORS.startStop())
    };
} 

class StartPause extends React.Component{
    constructor(props){
        super(props);
        
        this.handleStartStopClick = this.handleStartStopClick.bind(this);
    }
    
    //start or stops the timer
    handleStartStopClick(){
        this.props.startStopPressed();
        
        //only run timer if timer is active
        if(!this.props.timerActive){
            this.controlTimer();
        }
    }
     
    //handles the setInterval function
    controlTimer(){
        let timerID = setInterval(()=>{
            this.props.timerControler();
        },this.props.speedOfTimer);
        
        this.props.setTimerID(timerID);
    }
    
    render(){
        return(
            <div className='startPause outerWrapper'>
                <button id="start_stop" type='button' onClick = {this.handleStartStopClick}>Start/Pause</button>
                <audio id={this.props.audioID} src={CONSTANTS.ALARM}/>
            </div>
        )
    }
}

export default connect(CONSTANTS.MAP_STATE_TO_PROPS, mapDispatchToProps)(StartPause);